var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarName(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/CalendarFill") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.4992,0 L16.5665625,0 L16.5665625,2.76139747 C16.5665625,3.66454684 15.8746875,4.38683544 15.006,4.38683544 L14.514,4.38683544 C13.6453125,4.38683544 12.9534375,3.66493165 12.9534375,2.76139747 L12.9534375,0 L7.0340625,0 L7.0340625,2.76139747 C7.0340625,3.66454684 6.32911875,4.38683544 5.4612,4.38683544 L4.9692,4.38683544 C4.10128125,4.38683544 3.3825,3.66493165 3.3825,2.76139747 L3.3825,0 L1.1808,0 C0.53120625,0 0,0.567594937 0,1.24332152 L0,17.0113013 C0,17.6870278 0.53120625,18.24 1.1808,18.24 L18.4992,18.24 C19.1487937,18.24 19.68,17.6870278 19.68,17.0113013 L19.68,1.24332152 C19.68,0.567594937 19.1487937,0 18.4992,0 Z M18.0271875,15.6810127 C18.0257103,16.1585795 17.6393705,16.5453566 17.1623438,16.5468354 L2.51765625,16.5468354 C2.04062945,16.5453566 1.6542897,16.1585795 1.6528125,15.6810127 L1.6528125,6.83037975 C1.6542897,6.35281294 2.04062945,5.96603583 2.51765625,5.96455696 L17.1623438,5.96455696 C17.6393705,5.96603583 18.0257103,6.35281294 18.0271875,6.83037975 L18.0271875,15.6810127 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.757586441,5.28 C0.344298305,5.28 0,4.84656716 0,4.32526567 L0,0.943701493 C0,0.42318806 0.344298305,0 0.757586441,0 L1.17412881,0 C1.58741695,0 1.92,0.42318806 1.92,0.943701493 L1.92,4.32487164 C1.92,4.84656716 1.58741695,5.28 1.17412881,5.28 L0.757586441,5.28 Z M10.1460327,5.28 C9.72561887,5.28 9.39789474,4.84656716 9.39789474,4.32487164 L9.39789474,0.943307463 C9.39789474,0.42318806 9.72561887,0 10.1460327,0 L10.5697568,0 C10.9901706,0 11.3178947,0.42318806 11.3178947,0.943307463 L11.3178947,4.32487164 C11.3178947,4.84656716 10.9901706,5.28 10.5697568,5.28 L10.1460327,5.28 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.76,11.04 L9.12,11.04 L9.12,14.04 L5.76,14.04 L5.76,11.04 Z M5.76,15.24 L9.12,15.24 L9.12,18.24 L5.76,18.24 L5.76,15.24 Z M10.6472727,11.04 L14.0072727,11.04 L14.0072727,14.04 L10.6472727,14.04 L10.6472727,11.04 Z M10.6472727,15.24 L14.0072727,15.24 L14.0072727,18.24 L10.6472727,18.24 L10.6472727,15.24 Z M15.84,11.04 L19.2,11.04 L19.2,14.04 L15.84,14.04 L15.84,11.04 Z M15.84,15.24 L19.2,15.24 L19.2,18.24 L15.84,18.24 L15.84,15.24 Z",
    id: "path-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile-Friend-Request",
    transform: "translate(-914.000000, -226.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/CalendarFill",
    transform: "translate(912.000000, 225.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey-copy-2",
    transform: "translate(2.400000, 3.360000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    mask: "url(#mask-2)",
    fill: "#A5A5A5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.400000, -3.360000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))), /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey",
    transform: "translate(6.720000, 1.920000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-4)",
    fill: "#A5A5A5"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.720000, -1.920000)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))), /*#__PURE__*/React.createElement("g", {
    id: "colour/mid-grey"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-6)",
    fill: "#A5A5A5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarName);
export default __webpack_public_path__ + "static/media/calendarName.a42a25b824fd94ee478978823318f39e.svg";
export { ForwardRef as ReactComponent };